import './LinkForm.less';
import React, {useState, useEffect} from 'react';
import TextInput from '../../../../../bootstrap/components/text-input/TextInput';
import SingleSelect from '../../../../../bootstrap/components/single-select/SingleSelect';
import Button from '../../../../../bootstrap/components/button/Button';
import Icon from '../../../../../bootstrap/components/icon/Icon';
import LabelMap from '../../../../../bootstrap/types/label-map/LabelMap';
import __ from '../../../../i18n';

export default function FormDialog({initialLinkInfo, onDone, onCancel}) {
    const [linkUrl, setLinkUrl] = useState(initialLinkInfo.url);
    const [linkTitle, setLinkTitle] = useState(initialLinkInfo.title);
    const [linkTarget, setLinkTarget] = useState(initialLinkInfo.target);
    const [linkRel, setLinkRel] = useState(initialLinkInfo.rel);

    const getError = () => {
        if (!linkUrl || linkUrl.trim() === '') {
            return __('URL cannot be empty');
        }

        return null;
    };

    return <div className="link-form">
        <div className="title">
            <span className="text">{initialLinkInfo.text}</span>
            <Icon name="link"/>
        </div>

        <div className="field-name">{__('URL')}</div>
        <TextInput
            defaultValue={linkUrl}
            onChange={setLinkUrl}
        />

        <div className="field-name">{__('Title')}</div>
        <TextInput
            defaultValue={linkTitle}
            onChange={setLinkTitle}
        />

        <div className="group">
            <div>
                <div className="field-name">{__('Target')}</div>
                <SingleSelect
                    defaultValue={linkTarget}
                    options={new LabelMap([
                        ['_blank', 'Blank'],
                        ['_self', 'Self'],
                        ['_parent', 'Parent'],
                        ['_top', 'Top'],
                    ])}
                    onChange={setLinkTarget}
                    appearance="default"
                    removable={true}
                />
            </div>

            <div>
                <div className="field-name">{__('Rel')}</div>
                <SingleSelect
                    defaultValue={linkRel}
                    options={new LabelMap([
                        ['alternate', 'Alternate'],
                        ['author', 'Author'],
                        ['bookmark', 'Bookmark'],
                        ['external', 'External'],
                        ['help', 'Help'],
                        ['license', 'License'],
                        ['next', 'Next'],
                        ['nofollow', 'No Follow'],
                        ['noreferrer', 'No Referrer'],
                        ['noopener', 'No Opener'],
                        ['prev', 'Prev'],
                        ['search', 'Search'],
                        ['tag', 'Tag'],
                    ])}
                    onChange={setLinkRel}
                    appearance="default"
                    removable={true}
                />
            </div>
        </div>

        <div className="actions">
            <Button
                title={__('Cancel')}
                onClick={() => onCancel()}
                size="small"
                appearance="borderless-neutral"
            />

            <Button
                title={__('Apply')}
                onClick={() => onDone({
                    url: linkUrl,
                    title: linkTitle,
                    target: linkTarget,
                    rel: linkRel
                })}
                size="small"
                appearance="solid-primary"
                tooltip={getError()}
                disabled={getError() !== null}
            />
        </div>
    </div>
};

